import React, { useState } from "react";
import "../styles/SetPassword.css";
import { Link, useLocation } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import validateForm from "../utils/Validation";
import { USER_FORGOT_PASS_CHANGE_REQUEST } from "../store/Actions/Actions";

function ResetPassword() {

      const [formErrors,setFormErrors]=useState({})
      const [showPassword, setShowPassword] = useState(false);
        const FormReduxData = useSelector(_=>_?.forgotPassword?.forgotPasswordData)
       const dispatch = useDispatch();
         const isLoading = useSelector(_=>_?.forgotPassword?.isLoading)
        
        const onSubmitPassword=(e)=>{
           e.preventDefault();

            const formData = e.target;
  const payload = {password1:formData?.password1?.value,confirm_password:formData?.confirm_password?.value}

  
   const requiredFields = ["password1","confirm_password"];
      const errors = validateForm(payload, requiredFields);
      setFormErrors(errors);
    
    
      if (Object.keys(errors).length > 0) {
        return;
      }

        dispatch({type:USER_FORGOT_PASS_CHANGE_REQUEST,payload:{...payload,password:payload?.password1,email:FormReduxData?.email,server_ref:FormReduxData?.server_ref}});

        }

    console.log(formErrors);
        

    
  return (
    <div className="set-password-container">
      <div className="header move-top forgot-password-header">
        <Link to="/"><img src="../assets/images/logo.png" alt="Logo" className="logo" /></Link>
        <h2 className=" text-center fw-lighter text-body-secondary">
          Change Your Password
        </h2>
      </div>

      <div className="password-form-1">

       
        <form className="budget-form" onSubmit={onSubmitPassword}>
          <div className={`form-group flex-item ${formErrors.password1 ? 'has-error' : ''}`}>

            <label className="form-label fw-lighter">New Password</label>
            <input
              className="form-control"
              type="password"

              name="password1"
              placeholder="Set Your New Password"
            />
          </div>
           <div className={`form-group flex-item`}>
            <label className="form-label fw-lighter">Confirm Password</label>
            <div className={`input-group ${formErrors.confirm_password ? 'border-danger' : ''}`} >
                  <input className="form-control border-0 "    type={showPassword ? "text" : "password"} name="confirm_password" id="password"  placeholder="Re-enter new password" />

                    <span
        className="input-group-text bg-white border-0"
        style={{ cursor: "pointer",}}
        onClick={() => setShowPassword((s) => !s)}
      >
        {showPassword ? (
          <i className="bi bi-eye-slash"></i> // Bootstrap eye-slash icon
        ) : (
          <i className="bi bi-eye"></i> // Bootstrap eye icon
        )}
      </span>
</div>
        </div>
         
          <button className="btn btn-primary w-100 mt-3" type="submit">

            Reset Passoword
          </button>
        </form>
         {isLoading && (
              <div className='loading-login'>
            <img className='loading-login-img' src="/assets/images/l2.gif" />
          </div>
              )}

      </div>
        <span className="login-footer">
            © {new Date().getFullYear()} ProjeX. All rights reserved.
          </span>
    </div>
  );
}

export default ResetPassword;
